<mat-dialog-content>
  <h2 mat-dialog-title>
    {{ 'ACTIVATION.CONFIRMATION_PAGE.CHANGE_PRICE_DIALOG.EDIT_AMOUNT' | translate }}
  </h2>
  <p>
    {{ 'ACTIVATION.CONFIRMATION_PAGE.CHANGE_PRICE_DIALOG.YOU_CAN_INCREASE_AMOUNT' | translate }}
  </p>
  <form>
    <billing-ui-variable-price-input
      (spendAmountChanged)="handleOutputFromVariablePriceInputComponent($event)"
      [currentSpendAmount]="currentSpendAmountInCents"
      [appPrice]="data.item.appPrices.pricesForContexts['wholesale']"
      [currencyCode]="data.item.partnerCurrency"
    ></billing-ui-variable-price-input>
  </form>
</mat-dialog-content>
<mat-dialog-actions class="dialog-actions" align="end">
  <button mat-button mat-dialog-close color="primary" class="left-action-button">
    {{ 'COMMON.ACTION_LABELS.CANCEL' | translate }}
  </button>
  <button mat-raised-button color="primary" (click)="closeDialog()">
    {{ 'ACTIVATION.CONFIRMATION_PAGE.CHANGE_PRICE_DIALOG.APPLY_CHANGE' | translate }}
  </button>
</mat-dialog-actions>
